import React, { useMemo, useEffect, useState } from 'react'
import IPButton from '../../../../../components/IPButton'
import Table from '../../../../../components/Table'
import Swal from 'sweetalert2'
import { BaseComponentWithContextProps, componentWithContext } from '../../../../../base/customHooks/componentHOC'
import { useCustomReducer } from '../../../../../base/customHooks'
import IPModal from '../../../../../components/IPModal'
import { downloadFileFromUrl } from '../../../../../base/utils/dataHelper'
import IPSelectBox from '../../../../../components/IPSelectBox/IPSelectBoxMenu'
import { ISelectOption } from '../../../HomeAndSiteOperation/BulkAdding/components/BulkAdding'
import { ProductSubTypeDetailListApi } from '../services/getProductSubTypeReport'
import { IProductSubTypeRequestModel, IProductSubTypeResponseModel } from '../models/models'
import { getBrandApi, getCompanyApi } from '../../../components/api'
import { IBrand } from '../../OpportunityAisleProduct/models/opportunityMarketList'
import IPInput from '../../../../../components/IPInput'
import { CampaignBundleService } from '../../CampaignBundleCrud/services/CampaignBundleService'
import { ICompany } from '../../../components/models/models'

interface IProductSubTypeReport {
  selectedCompany?: ISelectOption
  ProductCode?: string
  MatNumber?: string
  Quota?: ISelectOption
  Brand?: ISelectOption
  selectedBrand?: ISelectOption
  SubTypeCode?: string
  DataList: IProductSubTypeResponseModel[]
  brandList?: IBrand[]
  productCodeOptions?: ISelectOption[]
  quotaCodeOptions?: ISelectOption[]
  companies: ISelectOption[]
}

function ProductSubTypeReport(props: BaseComponentWithContextProps) {
  const getInitialState = (): IProductSubTypeReport => {
    return {
      DataList: [],
      companies: [],
    }
  }

  const intialState = getInitialState()
  const [state, setState] = useCustomReducer<IProductSubTypeReport>(intialState)

  const productList = async () => {
    const requestData: IProductSubTypeRequestModel = {
      Company: state.selectedCompany?.value.toString(),
      ProductCode: state.ProductCode,
      MatNumber: state.MatNumber,
      Quota: state.Quota?.value.toString(),
      Brand: state.selectedBrand?.label.toString(),
      SubTypeCode: state.SubTypeCode,
    }
    props.showLoading()
    const productListApi: ProductSubTypeDetailListApi = new ProductSubTypeDetailListApi({})
    await productListApi
      .ProductSubTypeDetailList(requestData)
      .then(async result => {
        if (result) {
          setState({ DataList: result })
          props.hideLoading()
        }
      })
      .catch((err: any) => {
        Swal.fire({
          icon: 'error',
          title: err.description,
          showConfirmButton: true,
          allowOutsideClick: false,
        })
        props.hideLoading()
      })
  }

  useEffect(() => {
    getBrand()
    getProductCode()
    getCompanies()
  }, [])

  const getBrand = async () => {
    const data: any[] = await getBrandApi()
    setState({ brandList: data })
  }

  const getProductCode = async () => {
    const campaignBundleService = new CampaignBundleService({})
    const res = await campaignBundleService.getProductCode()
    if (res) {
      let temp = res.Entity.ProductsInfo.map(a => {
        return {
          label: a.ProductCode + '       ' + a.ProductName,
          value: a.ProductCode,
        }
      })
      setState({
        productCodeOptions: temp,
        quotaCodeOptions: res.Entity.QuotaCode.map(item => {
          return { label: item, value: item }
        }),
      })
    }
  }

  const getCompanies = async () => {
    try {
      const companyList: ICompany[] = await getCompanyApi()
      const companiesOptions: ISelectOption[] = companyList.map(company => ({
        label: company.Name,
        value: company.Code.toString(),
      }))
      setState({ companies: companiesOptions })
    } catch (err) {
      console.log('Fetch Companies Error:', err)
    }
  }


  const tableColumns = useMemo(
    () => [
      {
        Header: 'Sıra',
        accessor: 'col1',
      },
      {
        Header: 'Şirket',
        accessor: 'company',
      },
      {
        Header: 'Ürün Kodu',
        accessor: 'productCode',
      },
      {
        Header: 'Malzeme Numarası',
        accessor: 'materialNumber',
      },
      {
        Header: 'Ürün Adı',
        accessor: 'productName',
      },
      {
        Header: 'Ürün Müdürü',
        accessor: 'productMDName',
      },
      {
        Header: 'Marka',
        accessor: 'brand',
      },
      {
        Header: 'Kota',
        accessor: 'quota',
      },
      {
        Header: 'Kategori',
        accessor: 'category',
      },
      {
        Header: 'Alt Tip Kodu',
        accessor: 'subType',
      },
      {
        Header: 'Alt Tip Açıklaması',
        accessor: 'subTypeDescription',
      },
      {
        Header: 'Aktif',
        accessor: 'isActive',
      },
    ],
    []
  )

  const tableData = useMemo(
    () =>
      state.DataList?.map((item, index) => {
        const data = {
          col1: index + 1,
          company: item.Company,
          productCode: item.ProductCode,
          materialNumber: item.MatNumber,
          productName: item.ProductName,
          productMDName: item.MudName,
          brand: item.Brand,
          quota: item.Quota,
          category: item.Category,
          subType: item.SubTypeCode,
          subTypeDescription: item.SubTypeName,
          isActive: (item.Enabled && !item.Deleted) ? 'Evet' : 'Hayır',
        }

        return data
      }),
    [state.DataList]
  )

  return (
    <div className=''>
      <div className='content col-lg-12 m-auto'>
        <div className='card'>
          <div className='card-header d-flex justify-content-between'>
            <span className='h4'> Ürün Alt Tipi Tablosu (B2B)</span>
          </div>
          <div className="card-body">
            {/* ÜST SATIR (3 eleman) */}
            <div className="row justify-content-center g-4 align-items-end">
              <div className="col-12 col-lg-2">
                <IPSelectBox
                  isClearable
                  id="Şirket"
                  name="Şirket"
                  placeholder="Şirket"
                  options={state.companies}
                  value={state.selectedCompany}
                  onChangeSingle={(option) => setState({ selectedCompany: option })}
                />
              </div>

              <div className="col-12 col-lg-2">
                <IPSelectBox
                  isClearable
                  id="Brand"
                  name="Brand"
                  placeholder="Marka"
                  options={state.brandList?.map((brand) => ({ label: brand.Name, value: brand.Id })) || []}
                  value={state.selectedBrand as unknown as ISelectOption}
                  onChangeSingle={(option) => setState({ selectedBrand: option })}
                />
              </div>

              <div className="col-12 col-lg-2">
                <IPInput
                  type="text"
                  placeholder="Ürün Kodu"
                  value={state.ProductCode}
                  onChange={(e) => setState({ ProductCode: e.target.value })}
                />
              </div>

              <div className="col-12 col-lg-2">
                <IPInput
                  type="text"
                  placeholder="Malzeme Numarası"
                  value={state.MatNumber}
                  onChange={(e) => setState({ MatNumber: e.target.value })}
                />
              </div>
            </div>

            {/* ALT SATIR (3 eleman + buton sağ altta) */}
            <div className="row justify-content-center g-4 align-items-end mt-1">

              <div className="col-12 col-lg-2">
                <IPSelectBox
                  placeholder="Kota"
                  options={state.quotaCodeOptions}
                  value={state.Quota}
                  isClearable
                  onChangeSingle={(option) => setState({ Quota: option })}
                />
              </div>

              <div className="col-12 col-lg-4">
                <IPInput
                  type="text"
                  placeholder="Alt Tip Kodu"
                  value={state.SubTypeCode}
                  onChange={(e) => setState({ SubTypeCode: e.target.value })}
                />
              </div>

              <div className="col-12 col-lg-2">
                <div className="d-flex justify-content-end">
                  <IPButton text="Getir" onClick={productList} />
                </div>
              </div>
            </div>
            <label className="text-danger mt-3">Kota listesi redisten okumaktadır. Eksik veya boş olduğu durumlarda redisin dolması gerekir.</label>

            {/* TABLO */}
            <div className="row">
              <div className="col-lg-12">
                <div id="datatable_wrapper" className="dataTables_wrapper dt-bootstrap4">
                  <div className="row">
                    <div className="col-sm-14 mt-5">
                      <Table columns={tableColumns} data={tableData} currentPage={0} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default componentWithContext(ProductSubTypeReport)

